import React from 'react'
import { connect } from 'react-redux'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { Page } from '../../../components/page/Page'
import { routes } from '../../../constants'
import { actions } from '../crudDinamico.actions'
import { CrudDinamicoForm } from './CrudDinamicoForm'
import _ from 'lodash'
import '../../../index.scss'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  return {
    chave: state.crudCrudDinamicoState.chave,
    definicao: state.crudCrudDinamicoState.definicao,
    messages: state.crudCrudDinamicoState.messages,
    record: state.crudCrudDinamicoState.currentRecord,
    isSaving: state.crudCrudDinamicoState.isSaving,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const chave = ownProps.match.params.chave
  return {
    carregarDefinicao: (onSuccess) => dispatch(actions.carregarDefinicao(chave, onSuccess)),
    loadById: (oid) => dispatch(actions.loadById(oid)),
    saveHandler: () => dispatch(actions.save()),
    removeHandler: () => dispatch(actions.remove()),
    newHandler: () => dispatch(actions.makeNew()),
    setField: (field, value) => dispatch(actions.setField(field, value)),
  }
}

class CrudDinamicoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    // contrato do DefaultFormToolBar: state.showDialogRemove + hideDialog (ver BandeiraFormPageContainer)
    this.state = {
      showDialogRemove: false,
    }
    const chave = this.getChave()
    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_CRUD_DINAMICO}/${chave}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CRUD_DINAMICO}/${chave}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_CRUD_DINAMICO}/${chave}`)
    }
  }

  getChave = () => {
    return this.props.match.params.chave
  }

  getOid = () => {
    const oid = _.get(this, 'props.match.params.id', null)
    return oid && parseInt(oid) ? oid : null
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.carregarDefinicao(() => {
      const oid = this.getOid()
      if (oid) {
        this.props.loadById(oid)
      } else {
        this.props.newHandler()
      }
    })
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_CRUD_DINAMICO}/${this.getChave()}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <CrudDinamicoForm
        record={this.props.record}
        definicao={this.props.definicao}
        history={this.props.history}
        setField={this.props.setField}
      />
    )
    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CrudDinamicoFormPageContainer)
